import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import { signOut } from 'firebase/auth';
import NotificationBell from './NotificationBell';
import { useTheme } from './ThemeContext';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import ProfilePicture from './ProfilePicture';

const Navbar = ({ 
  isAuthenticated, 
  setIsAuthenticated, 
  darkMode, 
  setDarkMode, 
  user, 
  userProfile
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { currentUser, userRole } = useContext(AuthContext);

  useEffect(() => {
    // console.log('Navbar User Role:', {
    //   role: userRole,
    //   isAuthenticated: !!currentUser,
    //   uid: currentUser?.uid
    // });
  }, [userRole, currentUser]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsAuthenticated(false);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  const handleMenuItemClick = (action) => {
    action();
    setIsOpen(false);
  };

  return (
    <nav className="bg-white/10 backdrop-blur-lg shadow-lg fixed w-full top-0 z-50 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img
                className="h-12 w-auto"
                src="/logo.png"
                alt="Dreamarium"
              />
              <span className="ml-2 text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 text-transparent bg-clip-text">
                Dreamarium
              </span>
            </Link>
          </div>

          <div className="flex items-center">
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:focus:ring-gray-700"
              aria-label="Toggle dark mode"
            >
              {darkMode ? (
                <FaSun className="w-5 h-5" />
              ) : (
                <FaMoon className="w-5 h-5" />
              )}
            </button>
            {currentUser ? (
              <div className="flex items-center space-x-4">
                <NotificationBell />
                <div className="relative">
                  <button onClick={() => setIsOpen(!isOpen)} className="flex items-center space-x-2 focus:outline-none">
                  {currentUser && (
                  <ProfilePicture
                    imageUrl={userProfile?.profilePic} 
                    size="md" 
                    onClick={() => setIsOpen(!isOpen)}
                    className="h-10 w-10 rounded-full"
                  />
                )} 
                    {/* <img
                      src={userProfile?.profilePic || '/logo.png'}
                      alt="Profile"
                      className="h-8 w-8 rounded-full object-cover bg-gray-100 dark:bg-gray-700"
                    /> */}
                  </button>
                  {isOpen && (
                    <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white dark:bg-gray-700 ring-1 ring-black ring-opacity-5 z-50">
                      <button
                        onClick={() => handleMenuItemClick(() => navigate(`/dreamer/${user?.username}`))}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                      >
                        Profile
                      </button>
                      <button
                        onClick={() => handleMenuItemClick(() => navigate('/help'))}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                      >
                        Help & Support
                      </button>
                      <button
                        onClick={() => handleMenuItemClick(() => navigate('/'))}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                      >
                        Feed
                      </button>
                      <button
                        onClick={() => handleMenuItemClick(() => navigate('/network'))}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                      >
                        Dreamers Network
                      </button>
                      <button
                        onClick={() => handleMenuItemClick(() => navigate('/caught-dreams'))}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                      >
                        Caught Dreams
                      </button>
                      <button
                        onClick={() => handleMenuItemClick(() => navigate('/settings'))}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                      >
                        Settings
                      </button>
                      {/* Conditionally render Admin Dashboard */}
                      {userRole === 'admin' && (
                        <button
                          onClick={() => handleMenuItemClick(() => navigate('/admin'))}
                          className="block w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600"
                        >
                          Admin Dashboard
                        </button>
                      )}
                      <div className="border-t border-gray-200 dark:border-gray-700"></div>
                      <button
                        onClick={() => handleMenuItemClick(handleLogout)}
                        className="block w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-600"
                      >
                        Sign Out
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <Link
                  to="/login"
                  className="text-white hover:bg-purple-800 px-3 py-2 rounded-md text-sm font-medium"
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="ml-4 text-white hover:bg-purple-800 px-3 py-2 rounded-md text-sm font-medium"
                >
                  Sign Up
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
